import React, { useEffect, useState } from "react";
import { useAuthConfig } from "../shared/helper";
import { Box, Typography, useToastProvider } from "@deere/fuel-react";
import { SpecialAwardsDialog } from "./SpecialAwardsDialog";
import { Loading } from "../shared/Loading";

export const SpecialAwards = ({supplierNumber}) => {
    const authAxios = useAuthConfig();
    const { enqueueToast } = useToastProvider();
    const [isLoading, setIsLoading] = useState(false);
    const [specialAwards, setSpecialAwards] = useState([]);

    const getSpecialAwards = async (supplierNumber) => {
        try {
            return await authAxios.get(`/suppliers/${supplierNumber}/specialAwards`, {
                supplierNumber
            });
        } catch (e) {
            enqueueToast({
                variant: "error",
                title: "Error fetching special awards",
                message: e.response ? e.response.data[e.response.status.toString()] : "",
                isPersistent: true
            });
        }
    }

    const fetchSpecialAwards = () => {
        setIsLoading(true);
    
        supplierNumber && getSpecialAwards(supplierNumber)
            .then((response) => setSpecialAwards(response.data.awards))
            .then(() => setIsLoading(false))
    }

    useEffect(() => {
        fetchSpecialAwards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (isLoading) {
        return (
            <Loading/>
        )
    }
    
    return (
        <>
            <Box mb={1} mt={1} sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '2px'
            }}>
                {specialAwards.slice(0, 3).map((award) => (
                    <Box key={award.description} sx={{display: 'flex', gap: '5px'}}>
                        <Typography fontWeight="semibold">{award.description}</Typography>
                        -
                        <Typography>{award.fiscalYear}</Typography>
                    </Box>
                ))}
            </Box>
            {specialAwards.length > 3 && <SpecialAwardsDialog specialAwards={specialAwards}/>}
        </>
    )
}